import React, { useState } from 'react';
import _ from 'lodash';
import Products from 'pages/home/ProductCatalog/Products';
import ProductDetails from 'pages/home/ProductCatalog/ProductDetails';
import Button from 'components/Button';
import {
  Container,
  Wrapper,
  CatalogSection,
  Title,
  Description,
  ProductSection,
} from 'styles/pages/home/product-catalog';

const ProductCatalog = ({ toggleSignUpDialog }) => {
  const [selectedProduct, selectProduct] = useState(null);

  return (
    <Container id='products-pricing'>
      <Wrapper>
        <CatalogSection>
          <Title>
            <h2>Product Catalog</h2>
            <h4>No Minimums. No Inventory. No Monthly Fees.</h4>
          </Title>

          <Description>
            <p>
              Free online platform for print-on-demand drop shipping and
              fulfillment.
            </p>
            <p>No upfront cost or risk.</p>
            <p>
              Diverse collection of competitively priced products of
              high-quality material and print.
            </p>
          </Description>
          <ProductSection>
            {!selectedProduct && (
              <Products onSelect={(id) => selectProduct(id)} />
            )}
            {selectedProduct && (
              <ProductDetails
                selectedCategoryId={selectedProduct}
                toggleSignUpDialog={toggleSignUpDialog}
                onBack={() => selectProduct(null)}
              />
            )}
          </ProductSection>
          <Button
            containerStyle={{
              borderRadius: '20px',
              padding: '11px 14px',
              background: '#000',
              gridArea: 'cta',
              display: 'grid',
              alignItems: 'center',
              color: '#fff',
              cursor: 'pointer',
              textAlign: 'center',
              textTransform: 'uppercase',
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: 'unset',
              letterSpacing: 'unset',
            }}
            title='Sign up for exact pricing'
            onClick={() =>
              _.isFunction(toggleSignUpDialog) && toggleSignUpDialog()
            }
          />
        </CatalogSection>
      </Wrapper>
    </Container>
  );
};

export default ProductCatalog;
